import React, { Component } from "react";
import { Menu } from "antd";

const SubMenu = Menu.SubMenu;

class SideNav extends Component {
    constructor(props) {
        super(props);
        let current = 'heredity';
        if (props.selectKey) {
            current = props.selectKey;
        }
        this.state = { current };
    }

    handleClick = e => {
        this.setState({ current: e.key });
    }

    render () {
        const { current } = this.state;
        return (
            <aside className="sidebar">
                <Menu
                    onClick={this.handleClick}
                    defaultOpenKeys={['sub1']}
                    selectedKeys={[current]}
                    mode="inline"
                >
                    <SubMenu key="sub1" title={<span><i className="icon iconfont">&#xe618;</i><span>项目启动</span></span>}>
                        <Menu.Item key="heredity">
                            <a href="#/startUp/heredity">遗传办</a>
                        </Menu.Item>
                        <Menu.Item key="siteStart">
                            <a href="#/startUp/siteStart">中心启动记录</a>
                        </Menu.Item>
                    </SubMenu>
                </Menu>
            </aside>
        );
    }
}

export default SideNav;



// WEBPACK FOOTER //
// ./src/components/invStartUp/SideNav.js